<template lang="pug">
  router-view
</template>

<script>
export default {
  name: 'Root'
}
</script>
